import CalendarModal from "react-calendar";
import "react-calendar/dist/Calendar.css";
import React, { useState } from "react";
import "./CalendarModal.css";

export default function CalendarBody() {
  const [value, onChange] = useState(new Date());

  return (
    <div className="CalendarBody">
      <div className="calendarHead">
        <h1>Our Monthly Calendar</h1>
        <h2>
          Keep up to date with all the events happening at Claremont Main Road
          Mosque
        </h2>
      </div>
      <div className="container-calendar">
        <div className="containerParent">
          <div className="left-calendar" id="calendarModal">
            <CalendarModal
              onChange={onChange}
              value={value}
              className="calendar-item"
            />
          </div>
          <div className="right-calendar"></div>
        </div>
      </div>
    </div>
  );
}
